import { handleError, hostUrl, jsonHeaders, message, request } from "./core";

export const getBalance = (id) => {
  if (!id) return;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/balance"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};
